import React from "react";
import App from "./App";
import { Alerts, ErrorElement, StationIndex, ParametersIndex, ForecastIndex, Map, Parameter } from "./pages";
import { Station } from "./pages/stations";
import { PrivacyPolicy } from "./pages/privacy";
import { ParameterDefinitions } from "./pages/parameter-definitions";

export const MainRoutes = [
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorElement />,
        children: [
            {
                path: "parameter-definitions",
                element: <ParameterDefinitions />
            },
            {
                path: "privacy-policy",
                element: <PrivacyPolicy />
            },
            {
                path: "stations/",
                element: <StationIndex />,
            },
            {
                path: "alerts/",
                element: <Alerts />,
            },
            {
                path: "stations/:datasetId",
                element: <Station />,
                // loader: stationsLoader,
            },
            {
                path: "stations/:datasetId/:parameter",
                element: <Parameter />,
            },
            {
                path: "parameters/",
                element: <ParametersIndex />
            },
            {
                path: "forecasts/",
                element: <ForecastIndex />
            },
            {
                path: "/",
                element: <Map />
            }
        ],
    },
];
